import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { PedidoService } from '../../services/pedido.service';

@Component({
  selector: 'app-pagorespuesta3ds2',
  templateUrl: './pagorespuesta3ds2.component.html',
  styleUrls: ['./pagorespuesta3ds2.component.css']
})
export class Pagorespuesta3ds2Component implements OnInit {
  cargoid: string;

  constructor(private pedidoService: PedidoService,
              private router: Router) {
    this.cargoid = this.router.parseUrl(this.router.url).queryParams['id'];
  }

  ngOnInit(): void {
    sessionStorage.setItem('cargoId', this.cargoid);
    this.verificarPago(this.cargoid);
  }

  verificarPago(cargoid: string) {
    this.pedidoService.pagoRespuesta3DS2(cargoid).subscribe((resp: any) => {
      setTimeout(() => {
        const status = resp && resp.body ? resp.body.status : null;
        if (status === 'completed') {
          this.router.navigateByUrl('pagoexitoso');
        } else {
          this.router.navigateByUrl('pagorechazado/' + cargoid);
        }
      }, 7000);
    }, (err) => {
      switch (err.status) {
        case 0:
          Swal.fire({ icon: 'warning', text: 'No hay conexión con el servidor' });
          break;
        case 409:
          Swal.fire({ icon: 'error', text: 'Error ' + err.status + ' en Openpay' });
          break;
        case 500:
          Swal.fire({ icon: 'error', text: 'Error ' + err.status + ' — no fue posible conectar con Openpay' });
          break;
        default:
          Swal.fire({ icon: 'error', text: 'Error ' + err.status });
          break;
      }
    });
  }
}
